import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = { selectedItem: String }

    connect() {
        if (this.selectedItemValue) {
            this.selectFirstOfItem()
        }
        else {
            const timelineItems = document.querySelectorAll(".timeline-item")
            if (timelineItems.length === 0) return

            const firstParent = timelineItems[0].parentNode
            const firstId = firstParent?.dataset.itemId
            if (!firstId) return

            this.eventTimelineClick({ target: firstParent }, false)
        }
    }

    eventTimelineClick(event, setFirst = true) {
        const target = event.target
        let targetId = target.dataset.itemId
        if (!targetId) {
            targetId = target.parentNode.dataset.itemId
        }
        if (!targetId) {
            targetId = target.parentNode.parentNode.dataset.itemId
        }

        this.toggleTimeline(targetId)
        this.selectedItemValue = targetId
        if (setFirst) {
            this.selectFirstOfItem()
        }
    }

    toggleTimeline(targetId) {
        const timelineItems = document.querySelectorAll(".timeline-item")
        timelineItems.forEach(item => {
            const parent = item.parentNode
            const itemId = parent.dataset.itemId
            const childElement = item.children[0]

            if (itemId === targetId) {
                parent.removeAttribute('data-action')

                childElement.className = ''
                childElement.classList.add('custom-text', 'xl:text-[7.75rem]', 'lg:text-[5.0625rem]', 'text-[3.625rem]', 'text-gray-400')
            }
            else {
                if (!parent.dataset.action) {
                    parent.dataset.action = 'click->views--components--element--timeline-image-handler#eventTimelineClick'
                }
                childElement.className = ''
                childElement.classList.add(
                    'custom-text',
                    'text-black',
                    'xl:text-[7.75rem]',
                    'lg:text-[5.0625rem]',
                    'text-[3.625rem]',
                    'hover:underline',
                    'cursor-pointer'
                )
            }
        })
    }

    selectFirstOfItem() {
        if (!this.selectedItemValue) return
        this.toggleImagesFirst("carousel-image")
        this.toggleImagesFirst("big-carousel-image")
    }

    toggleImagesFirst(className) {
        const allImages = document.querySelectorAll(`.${className}`)
        allImages.forEach((item) => {
            item.classList.remove("block")
            if (!item.classList.contains("hidden")) {
                item.classList.add("hidden")
            }
        })

        const images = document.querySelectorAll(`.${className}.item-${this.selectedItemValue}`)
        if (images.length == 0) return

        images[0].classList.remove("hidden")
        if (!images[0].classList.contains("block")) {
            images[0].classList.add("block")
        }
        this.imageLoader(images[0])
    }

    imageLoader(target) {
        const input = target.querySelector("#image-backend-url")
        const imageElement = target.querySelector("#image")
        if (input && imageElement) {
            imageElement.src = input.value
        }
    }

    adaptTimelineToImage() {
        const visibleImage = document.querySelector(".carousel-image.block")
        if (!visibleImage) return

        const itemClass = [...visibleImage.classList].find(c => c.startsWith("item-"))
        const targetId = itemClass?.replace("item-", "")
        this.toggleTimeline(targetId)
    }
}
